module.exports = __webpack_public_path__ + "static/media/howItWorksScoutsIcon01.7ed517ab.svg";